import type { SearchableSelectConfig } from '@/components/SearchableSelect';

export const TICKETS_AGE_FILTERS = [
  { key: 'Less than 4 hours', value: 4 },
  { key: 'Less than 24 hours', value: 24 },
  { key: 'Less than 3 days', value: 24 * 3 },
  { key: 'Less than 7 days', value: 24 * 7 },
  { key: 'Rest', value: 99999 }
];

export enum TICKET_STATUS {
  DRAFT = 'Draft',
  OPEN = 'Open',
  ACKNOWLEDGED = 'Acknowledged',
  REMEDIATED = 'Remediated',
  COMPLETED = 'Completed',
  NEEDS_REVIEW = 'Needs Review',
  AUTO_CLOSED = 'Auto Closed'
}

export enum TICKET_STATUS_ID {
  DRAFT = '1',
  OPEN = '2',
  COMPLETED = '3',
  REMEDIATED = '4',
  ACKNOWLEDGED = '5',
  NEEDS_REVIEW = '6',
  AUTO_CLOSED = '7'
}

export enum TICKET_ORIGINATION_SOURCE {
  AI_SOC = 'kanati',
  TURBINE = 'turbine',
  MANUAL = 'manual',
  NOT_APPLICABLE = 'n/a'
}

export const CUSTOMER_FACING_TICKET_STATUSES = [
  TICKET_STATUS.OPEN,
  TICKET_STATUS.ACKNOWLEDGED,
  TICKET_STATUS.REMEDIATED,
  TICKET_STATUS.COMPLETED,
  TICKET_STATUS.AUTO_CLOSED
];

export const TICKET_GROUP_BY_FIELDS: string[] = [
  'assignee__name',
  'next_action',
  'owner__name',
  'resolution_id',
  'sub_category',
  'team_queue',
  'ticket_category__name',
  'ticket_priority__id',
  'ticket_priority__name',
  'ticket_status__name',
  'ticket_type',
  'user__name'
];

export const TICKETS_SEARCHABLE_SELECT_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'ticket_type',
    title: 'Type',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'buttongroup'
    },
    filterOptions: [
      {
        id: 1,
        label: 'Threat',
        value: '1'
      },
      {
        id: 2,
        label: 'Service',
        value: '2'
      }
    ]
  },
  {
    field: 'ticket_status__name',
    title: 'Status',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'ticket_priority__name',
    title: 'Priority',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'ticket_category__name',
    title: 'Category',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'owner__name',
    title: 'Owner',
    config: {
      searchable: true,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'team_queue',
    title: 'Team Queue',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'next_action',
    title: 'Next Action',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'user__name',
    title: 'Author',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'resolution_id',
    title: 'Resolution',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  }
];

export const TICKETS_SEARCH_FIELD_LABELS: Record<string, string> = {
  user__name: 'Author.Name'
};

export default TICKETS_SEARCHABLE_SELECT_FILTERS;
